package diana.soleil.design.iraniancanadienbazzar.feature.marketplace

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

/**
 * Hand-off for opening the sell composer from outside the Marketplace tab (the app shell's global
 * "Post" create sheet). Marketplace is a tab inside the main scaffold with no standalone sell route,
 * so the shell [requestSell]s, switches to the Market tab, and [MarketplaceRoute] observes
 * [pendingSell], opens the listing sheet, then [consume]s. Mirrors the feed's FeedDeepLinks pattern —
 * a process-wide object (not DI) so it can be set before the destination is composed.
 */
object MarketplaceIntents {
    private val _pendingSell = MutableStateFlow(false)
    val pendingSell: StateFlow<Boolean> = _pendingSell

    fun requestSell() {
        _pendingSell.value = true
    }

    fun consume() {
        _pendingSell.value = false
    }
}
